import { render, staticRenderFns } from "./SalesInvoiceDetail.vue?vue&type=template&id=4a5df97e&scoped=true&"
import script from "./SalesInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./SalesInvoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalesInvoiceDetail.vue?vue&type=style&index=0&id=4a5df97e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5df97e",
  null
  
)

export default component.exports